import React, { useState, useEffect } from 'react'
import axios from 'axios'
import MyIcon from '../../../components/general/icon'
import { Image } from 'antd'
import RibbonAlumniOrganization from './ribbon'
import AddAlumniOrganization from './add'
import EditAlumniOrganization from './edit'
import DeleteAlumniOrganization from './delete'

export default function AlumniOrganization() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [organizationList, setOrganizationList] = useState([])
  const [propsData, setPropsData] = useState({})
  const [isAddOrganizationVisible, setIsAddOrganizationVisible] = useState(false)
  const [isEditOrganizationVisible, setIsEditOrganizationVisible] = useState(false)
  const [isDeleteOrganizationVisible, setIsDeleteOrganizationVisible] = useState(false)

  const initialConditions = {
    category_oid: '',
    keywords: '',
    sort_filter: 0,
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getOrganizationList = () => {
    axios.post('/p/alumni/organization/list/get', { 
      merchant_oid: merchantOid,
      category_oid: filterValue.category_oid,
      keywords: filterValue.keywords,
      sort_filter: filterValue.sort_filter,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setOrganizationList(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getOrganizationList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, filterValue])

  const editOrganization = (oid) => {
    setIsEditOrganizationVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteOrganization = (oid, name) => {
    setIsDeleteOrganizationVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">组织管理</div>
          <RibbonAlumniOrganization 
            filterValue={filterValue} 
            setFilterValue={setFilterValue} 
            isAddVisible={() => { setIsAddOrganizationVisible(true) }}  
          />
        </div>

        <div className='public-main-style'>
          <div className='public-main-style2'>
            <table className='public-main-style2-item'>
              <thead>
                <tr className='public-main-style2-thead'>
                  <th style={{textAlign: 'left', paddingLeft: '20px'}}>组织名称</th>
                  <th>所属分类</th>
                  <th>成员数量</th>
                  <th>活动数量</th>
                  <th>排序</th>
                  <th style={{width: '50px'}}></th>
                </tr>
              </thead>

              <tbody>
                {organizationList && (organizationList.length > 0 ? (organizationList.map((item) => (
                  <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editOrganization(item.oid) }}>
                    {item.icon_url ? 
                      <div className='public-main-style2-tuwen'>
                        <div style={{margin: '10px 15px 10px 0'}} onClick={(event) => {event.stopPropagation()}}>
                          <Image src={item.icon_url} width={50} height={50} />
                        </div>
                        <span>{item.name}</span>
                      </div> : <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.name}</td>
                    }
                    <td>{item.category_name || '-'}</td>
                    <td>{item.member_number}</td>
                    <td>{item.event_number}</td>
                    <td>{item.sort}</td>
                    <td style={{width: '50px'}}>
                      <div className='public-main-style2-operation-box'>
                        <div className='public-main-style2-operation' 
                          onClick={(event) => {event.stopPropagation(); deleteOrganization(item.oid, item.name)}}>
                          <MyIcon name='huishouzhan' />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))) : (
                  <tr className='public-main-style2-tbodyEmpty'>
                    <td colSpan="6"><span>暂无数据</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {isAddOrganizationVisible && <AddAlumniOrganization
        getOrganizationList={getOrganizationList} 
        isOpen={isAddOrganizationVisible} 
        isCancel={() => { setIsAddOrganizationVisible(false) }} 
      />}

      {isEditOrganizationVisible && <EditAlumniOrganization
        data={propsData}
        getOrganizationList={getOrganizationList} 
        isOpen={isEditOrganizationVisible} 
        isCancel={() => { setIsEditOrganizationVisible(false) }} 
      />}

      {isDeleteOrganizationVisible && <DeleteAlumniOrganization
        data={propsData}
        getOrganizationList={getOrganizationList} 
        isOpen={isDeleteOrganizationVisible} 
        isCancel={() => { setIsDeleteOrganizationVisible(false) }} 
      />}
    </div>
  )
}
